import { render, staticRenderFns } from "./EditOppoConfig.vue?vue&type=template&id=5f433b7c&scoped=true&"
import script from "./EditOppoConfig.vue?vue&type=script&lang=js&"
export * from "./EditOppoConfig.vue?vue&type=script&lang=js&"
import style0 from "./EditOppoConfig.vue?vue&type=style&index=0&id=5f433b7c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f433b7c",
  null
  
)

export default component.exports